import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from '../../models/commonModel';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
  HttpStatusCode,
} from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import {
  Observable,
  catchError,
  of,
  tap,
  Subject,
  BehaviorSubject,
  throwError,
} from 'rxjs';
import { AppService } from '../app-service/app.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ErrorMessageConstants,
  TokenConstants,
} from '../../constants/message-constants';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private userImageSource = new BehaviorSubject<string | null>('');
  userImage$ = this.userImageSource.asObservable();
  private readonly errorMessage: string =
    'Something went wrong. Please try again after sometime.';
  setAutoHide: boolean = true;
  autoHide: number = 2000;
  private readonly encryptionKey = CryptoJS.enc.Utf8.parse(
    'EA34FF3E-JU84-1974-AW70-BB81D9564426'
  );
  private readonly KEY = CryptoJS.enc.Hex.parse(
    'c604f199ff095b4ced4caf373264e84045f71b384ce39628ee8adca2b27109e8'
  );
  private readonly IV = CryptoJS.enc.Hex.parse(
    '47b5b25d579c0bed815c9166b4f37ee8'
  );
  private readonly salt = CryptoJS.enc.Base64.parse('SXZhbiBNZWR2ZWRldg==');
  private readonly iterations = 100000;
  private readonly CryptoAlgo = CryptoJS.algo.SHA512;
  private logoutSubject = new Subject<void>();
  public logoutAction$ = this.logoutSubject.asObservable();
  public href: any;
  IsError: boolean = false;
  isSystemAlert: boolean = false;

  constructor(
    private readonly toster: ToastrService,
    private readonly dialog: MatDialog,
    private readonly spinner: NgxSpinnerService,
    private readonly appService: AppService,
    private readonly http: HttpClient,
    private readonly modalServices: NgbModal
  ) {}

  doGet(ApiUrl: String): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(),
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        'Bearer ' + loginData
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Origin',
        '*'
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Methods',
        'POST, GET, OPTIONS, DELETE, PUT'
      );
    }
    const url = `${environment.ApiUrl}${ApiUrl}`;
    return this.http.get<ApiResponse>(url, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError((error: HttpErrorResponse) => {
        this.checkAuthorize(error);
        return throwError(() => error);
      })
    );
  }

  getLocationDetails() {
    return this.http.get<ApiResponse>('https://ipapi.co/json/').pipe(
      tap(() => this.log(`doGet success`)),
      catchError((error: HttpErrorResponse) => {
        // this.checkAuthorize(error);
        return of(null);
      })
    );
  }

  doGetForDashboard(
    ApiUrl: String,
    options?: { params?: HttpParams }
  ): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(),
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        'Bearer ' + loginData
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Origin',
        '*'
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Methods',
        'POST, GET, OPTIONS, DELETE, PUT'
      );
    }
    const combinedOptions = { ...httpOptions, ...options };
    const url = `${environment.ApiUrl}${ApiUrl}`;
    return this.http.get<ApiResponse>(url, combinedOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError((error: HttpErrorResponse) => {
        this.spinner.hide();
        this.checkAuthorize(error);
        return throwError(() => error);
      })
    );
  }

  doPost(ApiUrl: string, postData: any): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(),
      
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        'Bearer ' + loginData
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Origin',
        '*'
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Methods',
        'POST, GET, OPTIONS, DELETE, PUT'
      );
    }
    const url = `${environment.ApiUrl}${ApiUrl}`;
    return this.http.post<ApiResponse>(url, postData, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError((error: HttpErrorResponse) => {
        this.spinner.hide();
        this.checkAuthorize(error);
        return throwError(() => error);
      })
    );
  }

  doPut(ApiUrl: string, putData: any): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(),
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        'Bearer ' + loginData
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Origin',
        '*'
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Methods',
        'POST, GET, OPTIONS, DELETE, PUT'
      );
    }
    const url = `${environment.ApiUrl}${ApiUrl}`;
    return this.http.put<ApiResponse>(url, putData, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError((error: HttpErrorResponse) => {
        this.spinner.hide();
        this.checkAuthorize(error);
        return throwError(() => error);
      })
    );
  }

  doDownloadPost(ApiUrl: string, postData: any) {
    const httpOptions = {
      headers: new HttpHeaders(),
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        'Bearer ' + loginData
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Methods',
        '*'
      );
    }
    const url = `${environment.ApiUrl}${ApiUrl}`;
    return this.http.post(url, postData, {
      headers: httpOptions.headers,
      observe: 'response',
      responseType: 'blob',
    });
  }

  doDelete(ApiUrl: String, idtoDelete: any): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(),
    };
    let loginData = localStorage.getItem('authToken');
    if (loginData) {
      httpOptions.headers = httpOptions.headers.set(
        'Authorization',
        'Bearer ' + loginData
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Origin',
        '*'
      );
      httpOptions.headers = httpOptions.headers.set(
        'Access-Control-Allow-Methods',
        'POST, GET, OPTIONS, DELETE, PUT'
      );
    }
    const options = {
      headers: httpOptions.headers,
      body: {
        UserId: idtoDelete,
      },
    };
    const url = `${environment.ApiUrl}${ApiUrl}`;
    return this.http.delete<ApiResponse>(url, httpOptions).pipe(
      tap(() => this.log(`doGet success`)),
      catchError((error: HttpErrorResponse) => {
        this.spinner.hide();
        this.checkAuthorize(error);
        return throwError(() => error);
      })
    );
  }

  // Check Authorize Role
  checkAuthorize(error: any) {
    console.log(error);
    this.spinner.hide();
    this.modalServices.dismissAll();
    this.dialog.closeAll();
    if (error.status == HttpStatusCode.Unauthorized) {
      if (!this.IsError) {
        this.spinner.hide();
        this.IsError = true;
        this.toster.error(ErrorMessageConstants.Message);
        // this.appService.logout();
        this.dialog.closeAll();
      }
    } else if (error.status == HttpStatusCode.Forbidden) {
      if (!this.IsError) {
        this.IsError = true;
        this.toster.error(TokenConstants.Session_Expired);
        // localStorage.clear();
        this.spinner.hide();
      }
      // this.appService.logout();
      this.spinner.hide();
      this.dialog.closeAll();
    } else {
      if (!this.IsError) {
        this.IsError = true;
        this.toster.error(ErrorMessageConstants.Message);
        let errorMessage =
          error.error.message != null ? error.error.message : error.message;
      }
    }
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.checkAuthorize(error);

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.IsError = false;
  }

  // Check form value changed or not
  onFormValueChange(status: any, initalValues: any, form: any): boolean {
    if (!status) {
      const initialValue = initalValues;
      let formUnchanged = Object.keys(initialValue).some(
        (key) => form[key] != initialValue[key]
      );
      return formUnchanged;
    } else {
      return false;
    }
  }

  DownloadCSVFile(apiUrl: String, postData: any): Observable<any> {
    const url = `${environment.ApiUrl}${apiUrl}`;
    return this.http.post<Blob>(url, postData, {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, DELETE, PUT',
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      }),
    });
  }

  setUserImage(imageSrc: string | null) {
    this.userImageSource.next(imageSrc);
  }

  getUserImage(): Observable<string | null> {
    return this.userImage$;
  }

  private formSubmittedSubject = new BehaviorSubject<boolean>(false);
  formSubmitted$ = this.formSubmittedSubject.asObservable();

  setFormSubmitted(value: boolean): void {
    this.formSubmittedSubject.next(value);
  }

  getFormSubmitted(): boolean {
    return this.formSubmittedSubject.value;
  }

  public Encrypt(clearText: string): string {
    let encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(clearText),
      this.KEY,
      {
        keySize: 128 / 8,
        iv: this.IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encodeURIComponent(encrypted.toString());
  }

  public Decrypt(cipherText: string): string {
    let decrypted = CryptoJS.AES.decrypt(
      decodeURIComponent(cipherText),
      this.KEY,
      {
        keySize: 128 / 8,
        iv: this.IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  isZipCodeValid(event: any) {
    let array = event?.split(' ');
    if (array.length <= 2 && array.length != 0) {
      if (event.trim() != '') {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  getTimeZone() {
    const timezoneOffset = new Date().getTimezoneOffset();
    const offset = Math.abs(timezoneOffset);
    const offsetOperator = timezoneOffset < 0 ? '+' : '-';
    const offsetHours = Math.floor(offset / 60)
      .toString()
      .padStart(2, '0');
    const offsetMinutes = Math.floor(offset % 60)
      .toString()
      .padStart(2, '0');
    if (offsetHours == '00' && offsetMinutes == '00') {
      return '+00:00';
    }
    return `${offsetOperator}${offsetHours}:${offsetMinutes}`;
  }

  makeDecimalRound(number: any) {
    let decimalPart = number - Math.floor(number);
    let decimalString = decimalPart.toFixed(2); // Convert decimal part to string with 2 decimal places
    let decimalDigits = parseInt(decimalString.slice(3)); // Get the digits after the decimal point

    if (decimalDigits > 5) {
      return Math.ceil(number * 100) / 100;
    } else {
      return Math.floor(number * 100) / 100;
    }
  }

  downloadPdf(url: string): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/pdf' });
    return this.http.get(url, { headers, responseType: 'blob' });
  }

  public EncryptForId(clearText: string): string {
    // As you're using Encoding.Unicde in .net, we have to use CryptoJS.enc.Utf16LE here.
    return CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf16LE.parse(clearText),
      this.KEY,
      {
        iv: this.IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();
  }

  public DecryptForId(cipherText: string): string {
    // As you're using Encoding.Unicde in .net, we have to use CryptoJS.enc.Utf16LE here.
    let decrypt = CryptoJS.AES.decrypt(cipherText, this.KEY, {
      iv: this.IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })
      .toString(CryptoJS.enc.Utf8)
      .toString();

    return decrypt.replaceAll('\x00', '').replaceAll(/&quot;/g, '"');
  }

  public getClaimStatusColor(status: string): string {
    switch (status) {
      case 'In Progress':
        return 'inprogress'; // Blue
      case 'Submitted to HMRC':
        return 'submitted-hmrc'; // Green
      case 'In Query by HMRC':
        return 'inquery-hmrc'; // Yellow
      case 'Rejected by HMRC':
        return 'rejected-hmrc'; // Red
      default:
        return 'inprogress'; // Default color - Blue
    }
  }

  doPostForAI(ApiUrl: string, postData: any): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders(),
    };
    // let loginData = localStorage.getItem('authToken');
    // if (loginData) {
    //   httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
    //   httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Origin', '*');
    //   httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
    // }
    const url = `${environment.AiApiUrl}${ApiUrl}`;
    return this.http.post<ApiResponse>(url, postData, httpOptions).pipe(
      tap(() => this.log(`doPost success`)),
      catchError((error: HttpErrorResponse) => {
        this.spinner.hide();
        this.checkAuthorize(error);
        return throwError(() => error);
      })
    );
  }
}
